function dynamicSort(property) {
   var sortOrder = 1;
   if(property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
   }
   return function (a,b) {
      if(!isNaN(a[property]) && !isNaN(b[property])){
         var result = (parseInt(a[property]) < parseInt(b[property])) ? -1 : (parseInt(a[property]) > parseInt(b[property])) ? 1 : 0;
      }else{
         var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      }
      return result * sortOrder;
   }
}

export {dynamicSort}